import Http from '@/api/request'

/**
 * 公共接口
 */
export const CommonApi = {
  // 获取token
  getToken (data) {
    return Http.get(`/v1/get_jwt?user_id=${data.user_id}`)
  },
  // 上报日志 \ 收集数据
  sendStat (data) {
    // return Http.post(`/v1/tracking/collection`, {
    return Http.trackApiPost(`/v1/tracking/collection`, {
      ...data,
      flag: 'isSimple'
    })
  },
  // 更新pushcid
  updateCid (data) {
    return Http.post(`/v2/handle_user_client`, data)
  },

  // 请求通知列表
  apiGetNotificationList (data: { page_size: number; offset: number }) {
    return Http.get(`/v3/announce?page_size=${data.page_size}&offset=${data.offset}`)
  },
  getCode (data) {
    return Http.post(`/v1/smscode`, data)
  },
  //  音乐人认证 短信发送
  get_musician_auth_sms_code (data) {
    return Http.post(`/v1/get_musician_auth_sms_code`, data)
  },
  // 提交H5登录数据
  sendLoginData (data) {
    return Http.post(`/v1/login/${data.code}`, data)
    // return Http.post(`/v1/login`, data)
  },
  // 提交安卓微信登录数据
  sendAndroidLoginData (data) {
    return Http.post(`/v1/applogin/${data.code}`, data)
  },
  loginByUionid (data: { openId: string; unionid: string; accessToken: string }) {
    return Http.post(`/v1/apploginbyunionid`, data)
  },
  phoneLogin (data) {
    return Http.post(`/v1/phone_login`, data)
  },
  // 绑定手机号
  apiBindMobile (data) {
    return Http.post(`/v2/bindphone`, { ...data, flag: 'isSimple' }, {
      'header': {
        'Authorization': data.token ? `Bearer ${data.token}` : ''
      }
    })
  },
  // 获取实人认证地址
  loadCertifyUri (data) {
    return Http.post(`/v2/user/init_face_verify`, data)
  },
  // 获取实人认证地址(无痕)
  loadCertifyUriPro (data) {
    return Http.post(`/v2/user/init_face_verify_pro`, data)
  },
  // 获取实人认证结果状态
  loadCertifyResult (data) {
    return Http.get(`/v2/user/describe_face_verify?certify_id=${data.certify_id}`)
  },
  // 歌曲详情
  getMusicDetail (data) {
    return Http.get(`/v2/music/${data.id}`)
  },
  // 歌曲详情
  getMusicDetailNoLogin (data) {
    return Http.get(`/v1/music_info`, data)
  },
  // 听歌完成
  apiCounterComplete () {
    return Http.post(`/v2/mine`)
  },
  // 微信分享获取初始化信息
  getWxSDKInitData (data) {
    return Http.post(`/v1/share/sign`, data)
  },
  // 全部音乐列表（不需要登录)
  getAllMusicListV1 (data) {
    return Http.get(`/v1/all_music_list`, data)
  },
  // 全部音乐列表（需要登录)
  getAllMusicList (data) {
    return Http.get(`/v2/all_music_list`, data)
  },
  // 每日推荐音乐列表（30首）
  getMusicDailyLists (data) {
    return Http.get(`/v3/music_daily_lists`, data)
  },
  // 全部音乐列表
  getAllMusicLists (data) {
    return Http.get(`/v3/plugin_music_lists`, data)
  },
  // 全部音乐列表
  getAllLikeMusicLists (data) {
    return Http.get(`/v2/my_favorite_all_lists`, data)
  },
  // 藏品馆音乐列表
  getAllCollectLists (data) {
    return Http.get(`/v2/my_assets_music_lists`, data)
  },
  // 音乐馆歌单播放列表
  hall_music_lists (data) {
    return Http.get(`/v2/hall_music_lists`, data)
  },
  // 首页超级搜索
  music_super_search (data) {
    return Http.get(`/v3/music_super_search`, data)
  },
  // 首页超级搜索
  music_sale_and_msg_list (data) {
    return Http.get(`/v1/music_sale_and_msg_list`, data)
  },
  // 支付宝支付
  order_confirm_ali_pay (data) {
    return Http.post(`/v2/order/confirm_ali_pay`, data)
  },
  // 支付宝取消支付  接口不用了
  // cancel_ali_payment(data){
  //   return Http.post(`/v2/cancel_ali_payment`, data)
  // }
}
